import React from 'react'

export interface TabFilterOption {
  value: string
  label: string
}

interface TabFilterProps {
  options: TabFilterOption[]
  activeValue: string
  onChange: (value: string) => void
  className?: string
}

const TabFilter: React.FC<TabFilterProps> = ({
  options,
  activeValue,
  onChange,
  className = '',
}) => {
  return (
    <div className={`mt-8px px-20px w-full flex items-center ${className}`}>
      {options.map((option) => {
        const isActive = activeValue === option.value
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`
              relative
              flex-1 flex items-center justify-center
              px-8px py-12px
              transition-all
              ${isActive ? '' : 'opacity-50'}
            `}
          >
            <span className="text-style-button1 text-brown-80%-main text-center">
              {option.label}
            </span>
            {isActive && (
              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full h-2px bg-brown-80%-main"></div>
            )}
          </button>
        )
      })}
    </div>
  )
}

export default TabFilter
